/* eslint-disable react/require-default-props */
import { format, parse } from 'date-fns';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';

import { Data } from '../types';

import { Container, Title } from './styles';

type Props = {
  data: Data;
  getDateFilterValues?: () => any;
};

export function Card({ data, getDateFilterValues }: Props) {
  const navigate = useHistory();

  const clickFunc = () => {
    if (data.title === 'Gestão de Faturamento') {
      window.open(data.url);
      return;
    }

    const { initial_date, final_date } =
      getDateFilterValues && getDateFilterValues();

    const startDate = initial_date
      ? format(parse(initial_date, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
      : `${new Date().getFullYear()}-01-01`;

    const endDate = final_date
      ? format(parse(final_date, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
      : new Date().toISOString().split('T')[0];

    navigate.push(data.url, {
      startDate,
      endDate,
    });
  };

  return (
    <Container onClick={clickFunc}>
      <Title>{data.title}</Title>
      <IoIosArrowBack color="#000" size="24" />
    </Container>
  );
}
